import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Home from "./screens/Home";
import Resume from "./screens/Resume";
import Press from "./screens/Press";
import Voice from "./screens/Voice";
import Gallery from "./screens/Gallery";
import Contact from "./screens/Contact";

const router = createBrowserRouter([
  {
    path: "/home",
    element: <Home/>,
  },
  {
    path: "/resume",
    element: <Resume/>,
  },
  {
    path: "/gallery",
    element: <Gallery/>,
  },
  {
    path: "/voice",
    element: <Voice/>,
  },
  {
    path: "/press",
    element: <Press/>,
  },
  {
    path: "/contact",
    element: <Contact/>,
  },
  {
    path: "/",
    element: <Home/>,
  },
]);

function App() {
  return (
    <RouterProvider router={router}/>
  );
}

export default App;
